<template>
  <div :class="sectionClass">
    <label :for="id" class="form-label">{{ label }}</label>
    <div class="p-inputgroup">
      <!-- <span
        class="p-inputgroup-addon"
        :class="{
          'invalid-icon': validation?.$error,
        }"
      >
        <span class="calendar-icon"></span>
      </span> -->
      <Calendar
        inputId="basic"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :disabledDays="disabledDays"
        :disabledDates="disabledDates"
        :manualInput="manualInput"
        :modelValue="modelValue"
        :minDate="minDate"
        :maxDate="maxDate"
        :aria-describedby="`${id}-help`"
        dateFormat="yyyy-mm-dd"
        showIcon="calander-icon"
        @date-select="$emit('update:modelValue', formatDate($event))"
      />
    </div>
    <!-- <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", this.label) }}
    </span> -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
      default: "",
    },
    PropName: {
      type: String,
      default: "",
    },
    validation: {
      type: Object,
      required: true,
    },
    modelstate: {
      type: String,
      default: "",
    },
    minlength: {
      type: String,
      default: "",
    },
    maxlength: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledDates: {
      type: Array,
      default: null,
    },
    disabledDays: {
      type: Array,
      default: null,
    },
    manualInput: {
      type: Boolean,
      default: true,
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },

  },
  methods: {
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
  },
};
</script>
